import { Action } from '@ngrx/store';
import { Event } from './event';

export type EventCreator<E extends Event = Event> = (action: Action) => E[];

export interface EventCreatorMap {
  [actionType: string]: EventCreator;
}

export const getEvents = (createEvents: EventCreator<Event>): EventCreator => (action: Action) => createEvents(action);
